import {
    createUseSocketStatus,
    createUseStream,
    SocketListener,
    StreamListener,
} from '@m43/sockets-mark43';
import type { StreamMap } from './stream-types';

export type CadNextSocketListener = SocketListener<StreamMap>;
export const useSocketStatus = createUseSocketStatus<StreamMap>();
export function createStreamListener<T extends Readonly<(keyof StreamMap)[]>>(
    streamListener: StreamListener<StreamMap, T>
): StreamListener<StreamMap, T> {
    return streamListener;
}
export const useStream = createUseStream<StreamMap>();
